const MenuData = [
    {
        id: 1,
        name: "Zinger Burger",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        rating: 4,
       quantity : 1,
        price: 25,
        preprice: "30$",
        category: "burger",
        Image: "https://img.freepik.com/free-photo/big-sandwich-hamburger-burger-with-beef-red-onion-tomato-fried-bacon_2829-5398.jpg?t=st=1653947378~exp=1653947978~hmac=9c72f35579233585771a39bd622f718dda183a2c7c286c4cd66027a6f45afeb1&w=740",
        sale: "SALE ON",
    
        images: [
            {
                image: "https://img.freepik.com/free-photo/big-sandwich-hamburger-burger-with-beef-red-onion-tomato-fried-bacon_2829-5398.jpg?t=st=1653947378~exp=1653947978~hmac=9c72f35579233585771a39bd622f718dda183a2c7c286c4cd66027a6f45afeb1&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
      ],
    
    },
    
    {
        id: 2,
        name: "Grill Burger",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 30,
        quantity : 1,
        rating: 5,
        preprice: "",
        category: "burger",
        Image: "https://img.freepik.com/free-photo/side-view-double-cheeseburger-with-grilled-beef-patties-cheese-lettuce-leaf-burger-buns_141793-4883.jpg?t=st=1653945477~exp=1653946077~hmac=b64eaa792ef988cdc1a450b83e1fea87fbf03ccdef7bbb999b36545f8988ad9c&w=740",
        sale: "",
    
        images: [
            {
                image: "https://img.freepik.com/free-photo/side-view-double-cheeseburger-with-grilled-beef-patties-cheese-lettuce-leaf-burger-buns_141793-4883.jpg?t=st=1653945477~exp=1653946077~hmac=b64eaa792ef988cdc1a450b83e1fea87fbf03ccdef7bbb999b36545f8988ad9c&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
      ],
    
    },
    
    
    {
        id: 3,
        name: "Chicken pizza",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 50,
        quantity : 1,
        rating: 3,
        preprice: "",
        category: "pizza",
        Image: "https://img.freepik.com/free-photo/mixed-pizza-with-various-ingridients_140725-3790.jpg?t=st=1653942582~exp=1653943182~hmac=a0ee439a94c972b18a3b63c72efcf40ae4e4d0cac3cde92a7d0847025ccea305&w=740",
        sale: "",
        images: [
            {
                image: "https://img.freepik.com/free-photo/mixed-pizza-with-various-ingridients_140725-3790.jpg?t=st=1653942582~exp=1653943182~hmac=a0ee439a94c972b18a3b63c72efcf40ae4e4d0cac3cde92a7d0847025ccea305&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
      ],
    },
    
    {
        id: 4,
        name: "Vegitable Pizza",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 70,
        rating: 4,
        quantity : 1,
        preprice: "",
        category: "pizza",
        Image: "https://img.freepik.com/free-photo/mix-pizza-chicken-tomato-bell-pepper-olives-mushroom-side-view_141793-3167.jpg?t=st=1653942582~exp=1653943182~hmac=a9176cd686ddfb06345127a9ef23c125ef76e05ddbf0a8dbf1756fdcbb4b66b3&w=740",
        sale: "",

        images: [
            {
                image: "https://img.freepik.com/free-photo/mix-pizza-chicken-tomato-bell-pepper-olives-mushroom-side-view_141793-3167.jpg?t=st=1653942582~exp=1653943182~hmac=a9176cd686ddfb06345127a9ef23c125ef76e05ddbf0a8dbf1756fdcbb4b66b3&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
      ],

    },
    
    {
        id: 5,
        name: "Beaf Pizza",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 20,
        quantity : 1,
        rating: 5,
        preprice: "40$",
        category: "pizza",
        Image: "https://img.freepik.com/free-photo/pizza-with-salami-tomatoes-olives-cheese-dough-with-whole-wheat-flour-italian-food_2829-6855.jpg?t=st=1654021593~exp=1654022193~hmac=8d8b2471fbeed68805e96958d41361aad2015f258b8911290905cfdb0952b586&w=740",
        sale: "SALE ON",

        images: [
            {
                image: "https://img.freepik.com/free-photo/pizza-with-salami-tomatoes-olives-cheese-dough-with-whole-wheat-flour-italian-food_2829-6855.jpg?t=st=1654021593~exp=1654022193~hmac=8d8b2471fbeed68805e96958d41361aad2015f258b8911290905cfdb0952b586&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
      ],

    },
    
    
    {
        id: 6,
        name: " Chinese Sushi ",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 30,
        quantity : 1,
        rating: 4,
        preprice: "",
        category: "sushi",
        Image: "https://img.freepik.com/free-photo/side-view-mix-sushi-rolls-tray-with-ginger-wasabi_141793-14242.jpg?t=st=1653945937~exp=1653946537~hmac=588b7bf0c7a93e6f0054ffce05b816d14cc2df8bc00ccc4b8150dc7d5c36b91d&w=740",
        sale: "",

        images: [
            {
                image: "https://img.freepik.com/free-photo/side-view-mix-sushi-rolls-tray-with-ginger-wasabi_141793-14242.jpg?t=st=1653945937~exp=1653946537~hmac=588b7bf0c7a93e6f0054ffce05b816d14cc2df8bc00ccc4b8150dc7d5c36b91d&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
      ],

    },
    
    
    {
        id: 7,
        name: " philadelphia roll ",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 36,
        quantity : 1,
        rating: 4,
        preprice: "",
        category: "sushi",
        Image: "https://img.freepik.com/free-photo/side-view-philadelphia-roll-with-conger-eel-crab-meat-avocado-cucumber-teriyaki-sauce-ginger-wasabi-tray_141793-5046.jpg?t=st=1653945937~exp=1653946537~hmac=5dbf15b3147b7ef13ebbed7909634bcc664f6883a7ed0ad940abdb5253ff608b&w=740",
        sale: "",


        images: [
            {
                image: "https://img.freepik.com/free-photo/side-view-philadelphia-roll-with-conger-eel-crab-meat-avocado-cucumber-teriyaki-sauce-ginger-wasabi-tray_141793-5046.jpg?t=st=1653945937~exp=1653946537~hmac=5dbf15b3147b7ef13ebbed7909634bcc664f6883a7ed0ad940abdb5253ff608b&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
      ],

    },
    
    {
        id: 8,
        name: "Greek salad ",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 10,
        rating: 5,
        quantity : 1,
        preprice: "",
        category: "salat",
        Image: "https://img.freepik.com/free-photo/greek-salad-with-fresh-vegetables-feta-cheese-kalamata-olives_2829-10848.jpg?t=st=1653944564~exp=1653945164~hmac=694f3fbf82c7016240f1f740f35b9cdcdb77b295d915f6d0b2f7441a4ff54493&w=826",
        sale: "",
        images: [
            {
                image: "https://img.freepik.com/free-photo/greek-salad-with-fresh-vegetables-feta-cheese-kalamata-olives_2829-10848.jpg?t=st=1653944564~exp=1653945164~hmac=694f3fbf82c7016240f1f740f35b9cdcdb77b295d915f6d0b2f7441a4ff54493&w=826",
      },
      {
            image: "https://img.freepik.com/free-photo/side-view-delicious-vegetarian-meal-plate-purple-stripped-towel-dark-background_140725-130417.jpg?t=st=1654888690~exp=1654889290~hmac=f8978389ef98f1f0c3a75d26325860c2897892362634fe0961be0fa7384a05aa&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/top-view-salad-with-different-ingredients-dark-plate_23-2148537175.jpg?t=st=1654888613~exp=1654889213~hmac=3ababa987f894621db67916f748861486f4499398ec6b223eb24b6735b926076&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/top-view-caesar-salad-oval-grey-plate-green-white-checkered-tablecloth-dark-red-background_140725-124350.jpg?t=st=1654888690~exp=1654889290~hmac=2d7198257959eb570f5daa897e217a9e2776052dcb08493e8fa41c71c9454c24&w=740",
},
      ],

    },
    
    {
        id: 9,
        name: "chicken salad",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 15,
        rating: 3,
        quantity : 1,
        preprice: "20$",
        category: "salat",
        Image: "https://img.freepik.com/free-photo/salad-chicken-breast-with-zucchini-cherry-tomatoes_2829-8505.jpg?t=st=1653944564~exp=1653945164~hmac=2713898100f68d20187f4ad4d28f8306d6a1bc504eddd83e4abc900a6c157511&w=740",
        sale: "SALE ON",

        images: [
            {
                image: "https://img.freepik.com/free-photo/salad-chicken-breast-with-zucchini-cherry-tomatoes_2829-8505.jpg?t=st=1653944564~exp=1653945164~hmac=2713898100f68d20187f4ad4d28f8306d6a1bc504eddd83e4abc900a6c157511&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/side-view-delicious-vegetarian-meal-plate-purple-stripped-towel-dark-background_140725-130417.jpg?t=st=1654888690~exp=1654889290~hmac=f8978389ef98f1f0c3a75d26325860c2897892362634fe0961be0fa7384a05aa&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/top-view-salad-with-different-ingredients-dark-plate_23-2148537175.jpg?t=st=1654888613~exp=1654889213~hmac=3ababa987f894621db67916f748861486f4499398ec6b223eb24b6735b926076&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/top-view-caesar-salad-oval-grey-plate-green-white-checkered-tablecloth-dark-red-background_140725-124350.jpg?t=st=1654888690~exp=1654889290~hmac=2d7198257959eb570f5daa897e217a9e2776052dcb08493e8fa41c71c9454c24&w=740",
},
      ],
    },
    
    {
        id: 10,
        name: "Chocolate cake",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 22,
        rating: 5,
        quantity : 1,
        preprice: "",
        category: "desert",
        Image: "https://img.freepik.com/free-photo/front-view-sweet-chocolate-cake_23-2148834059.jpg?t=st=1654021012~exp=1654021612~hmac=b385af82d89fb8acbd77c635bc6853c34565033021c38c9a45f8d303a735e1f1&w=900",
        sale: "",

        images: [
            {
                image: "https://img.freepik.com/free-photo/front-view-sweet-chocolate-cake_23-2148834059.jpg?t=st=1654021012~exp=1654021612~hmac=b385af82d89fb8acbd77c635bc6853c34565033021c38c9a45f8d303a735e1f1&w=900",
      },
      {
            image: "https://img.freepik.com/free-photo/sponge-cake-with-strawberries-top_144627-45517.jpg?t=st=1654889048~exp=1654889648~hmac=2401a3a76cb5174dab4308210a31609252f7e0381ec605f6b8d12e862969e71c&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/assortment-pieces-cake_114579-28298.jpg?t=st=1654889048~exp=1654889648~hmac=e0f48369eefeaa89e954ec6f3dac8a179a3bf872fd385b06f720d7c42b4fda75&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/stunning-birthday-cake-covered-with-pink-icing-roses_8353-1076.jpg?t=st=1654889048~exp=1654889648~hmac=51e0b8842f21bd8981ad8fa2406f10145b170fe8e0454af69e1c3808c29476d9&w=740",
},
      ],
    },
    
    {
        id: 11,
        name: "Cheese Burger",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 50,
        rating: 3,
        preprice: "",
        quantity : 1,
        category: "burger",
        Image: "https://img.freepik.com/free-photo/front-view-burger-stand_141793-15542.jpg?t=st=1654017967~exp=1654018567~hmac=8cd7f77f28e287a45a2b0c9e26c408993116ab12a5a122253a576275077e7d3f&w=740",
        sale: "",
    
        images: [
            {
                image: "https://img.freepik.com/free-photo/front-view-burger-stand_141793-15542.jpg?t=st=1654017967~exp=1654018567~hmac=8cd7f77f28e287a45a2b0c9e26c408993116ab12a5a122253a576275077e7d3f&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
      ],
    
    },
    
    {
        id: 12,
        name: "Beaf Burger",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 46,
        rating: 3,
        quantity : 1,
        preprice: "",
        category: "burger",
        Image: "https://img.freepik.com/free-photo/chicken-burger-wooden-board-side-view_141793-2753.jpg?t=st=1654000347~exp=1654000947~hmac=ba3050dcdafc6a516a27a90c676c524253807dc30f951b0c45f7e865bb8bc9a3&w=740",
        sale: "",
        images: [
            {
                image: "https://img.freepik.com/free-photo/chicken-burger-wooden-board-side-view_141793-2753.jpg?t=st=1654000347~exp=1654000947~hmac=ba3050dcdafc6a516a27a90c676c524253807dc30f951b0c45f7e865bb8bc9a3&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
      ],
    },
    
    {
        id: 13,
        name: "Russian salad",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 23,
        rating: 4,
        quantity : 1,
        preprice: "20$",
        category: "salat",
        Image: "https://img.freepik.com/free-photo/salad-with-tuna-tomatoes-potato-onion_2829-10301.jpg?t=st=1654020292~exp=1654020892~hmac=5fac5ecd6e6573ff14240bd1a4081de086dd39956d3bcedb7deaa1f9f1465a5f&w=740",
        sale: "SALE ON",

        images: [
            {
                image: "https://img.freepik.com/free-photo/salad-with-tuna-tomatoes-potato-onion_2829-10301.jpg?t=st=1654020292~exp=1654020892~hmac=5fac5ecd6e6573ff14240bd1a4081de086dd39956d3bcedb7deaa1f9f1465a5f&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/side-view-delicious-vegetarian-meal-plate-purple-stripped-towel-dark-background_140725-130417.jpg?t=st=1654888690~exp=1654889290~hmac=f8978389ef98f1f0c3a75d26325860c2897892362634fe0961be0fa7384a05aa&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/top-view-salad-with-different-ingredients-dark-plate_23-2148537175.jpg?t=st=1654888613~exp=1654889213~hmac=3ababa987f894621db67916f748861486f4499398ec6b223eb24b6735b926076&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/top-view-caesar-salad-oval-grey-plate-green-white-checkered-tablecloth-dark-red-background_140725-124350.jpg?t=st=1654888690~exp=1654889290~hmac=2d7198257959eb570f5daa897e217a9e2776052dcb08493e8fa41c71c9454c24&w=740",
},
      ],
    },
    {
        id: 14,
        name: "Fruits salad",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 12,
        quantity : 1,
        rating: 4,
        preprice: "",
        category: "salat",
        Image: "https://img.freepik.com/free-photo/top-view-delicious-fruit-salad-inside-plate-with-fresh-fruits-gray-fruit-tree-exotic-tropical-photo-ripe-diet_140725-109945.jpg?t=st=1654020292~exp=1654020892~hmac=7b29995dd7eeccabfc6467fb6ae3fe191d06fb4432e600d909edbb67180db4ab&w=740",
        sale: "",

        images: [
            {
                image: "https://img.freepik.com/free-photo/top-view-delicious-fruit-salad-inside-plate-with-fresh-fruits-gray-fruit-tree-exotic-tropical-photo-ripe-diet_140725-109945.jpg?t=st=1654020292~exp=1654020892~hmac=7b29995dd7eeccabfc6467fb6ae3fe191d06fb4432e600d909edbb67180db4ab&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/side-view-delicious-vegetarian-meal-plate-purple-stripped-towel-dark-background_140725-130417.jpg?t=st=1654888690~exp=1654889290~hmac=f8978389ef98f1f0c3a75d26325860c2897892362634fe0961be0fa7384a05aa&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/top-view-salad-with-different-ingredients-dark-plate_23-2148537175.jpg?t=st=1654888613~exp=1654889213~hmac=3ababa987f894621db67916f748861486f4499398ec6b223eb24b6735b926076&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/top-view-caesar-salad-oval-grey-plate-green-white-checkered-tablecloth-dark-red-background_140725-124350.jpg?t=st=1654888690~exp=1654889290~hmac=2d7198257959eb570f5daa897e217a9e2776052dcb08493e8fa41c71c9454c24&w=740",
},
      ],
    },
    
    {
        id: 15,
        name: "Cheese Pizza",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 32,
        quantity : 1,
        rating: 5,
        preprice: "",
        category: "pizza",
        Image: "https://img.freepik.com/free-photo/traditional-supreme-pizza-rustic-wooden-table_123827-20264.jpg?t=st=1654021593~exp=1654022193~hmac=2d5955bc39647a52766d496b74e66602764516189faed64b84cac8f752a3993e&w=740",
        sale: "",

        images: [
            {
                image: "https://img.freepik.com/free-photo/traditional-supreme-pizza-rustic-wooden-table_123827-20264.jpg?t=st=1654021593~exp=1654022193~hmac=2d5955bc39647a52766d496b74e66602764516189faed64b84cac8f752a3993e&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
      ],

    },
    
    {
        id: 16,
        name: "Korean Sushi",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 50,
        quantity : 1,
        rating: 5,
        preprice: "",
        category: "sushi",
        Image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-43007.jpg?t=st=1654020709~exp=1654021309~hmac=2c3503627c0ca108b1a91aa7688fcd59e491ab2b970822ab29785af3888fff11&w=740",
        sale: "",

        
        images: [
            {
                image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-43007.jpg?t=st=1654020709~exp=1654021309~hmac=2c3503627c0ca108b1a91aa7688fcd59e491ab2b970822ab29785af3888fff11&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
      ],
    },
    
    {
        id: 17,
        name: "Traditional Sushi",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 33,
        quantity : 1,
        rating: 3,
        preprice: "",
        category: "sushi",
        Image: "https://img.freepik.com/free-photo/traditional-sushi-dark-surface_1150-42063.jpg?t=st=1654020709~exp=1654021309~hmac=18828f5b829cdefbdc331c2e507ee5cacc9cd447f822010e66e8dab95978cfa0&w=740",
        sale: "",
        
        images: [
            {
                image: "https://img.freepik.com/free-photo/traditional-sushi-dark-surface_1150-42063.jpg?t=st=1654020709~exp=1654021309~hmac=18828f5b829cdefbdc331c2e507ee5cacc9cd447f822010e66e8dab95978cfa0&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
      ],
    },
    
    {
        id: 18,
        name: "Ice Cone",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 24,
        quantity : 1,
        rating: 4,
        preprice: "30$",
        category: "desert",
        Image: "https://img.freepik.com/free-photo/top-view-set-ice-cream-cones-with-chocolate_23-2148425392.jpg?t=st=1654021066~exp=1654021666~hmac=9e462a69a5a7dd5c4b5305d4219e025abc29ad60bffb6941a3acca4c0f681761&w=740",
        sale: "SALE ON",

      
        images: [
            {
                image: "https://img.freepik.com/free-photo/top-view-set-ice-cream-cones-with-chocolate_23-2148425392.jpg?t=st=1654021066~exp=1654021666~hmac=9e462a69a5a7dd5c4b5305d4219e025abc29ad60bffb6941a3acca4c0f681761&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/ice-cream-cone_144627-41497.jpg?t=st=1654889259~exp=1654889859~hmac=87242439c775f68064a293a6deb8cbe23becce466ba5d50dee9b082c36a358c0&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/top-view-homemade-ice-cream-scoops-concept_23-2148425380.jpg?t=st=1654889310~exp=1654889910~hmac=fbacb7be231b700ddaef9114b9533bf89571d179a17375f97241df08c0cb23db&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/ice-cream-with-bananas-chocolate-sprinkles-white-plate_114579-33759.jpg?t=st=1654889401~exp=1654890001~hmac=7fb9105f6717da2d2886c995299c5a5df7217d9821c830807cea0e85b607013b&w=740",
},
      ],

    },
    
    {
        id: 19,
        name: "Chocolate Ice Cream",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 21,
        rating: 5,
        quantity : 1,
        preprice: "",
        category: "desert",
        Image: "https://img.freepik.com/free-photo/chocolate-ice-cream-dessert_144627-8363.jpg?t=st=1654021235~exp=1654021835~hmac=9b373d5f0695bf7976867710d69845cc7a5f8f4484b2d6868ce7df3133a9157a&w=826",
        sale: "",

        images: [
            {
                image: "https://img.freepik.com/free-photo/chocolate-ice-cream-dessert_144627-8363.jpg?t=st=1654021235~exp=1654021835~hmac=9b373d5f0695bf7976867710d69845cc7a5f8f4484b2d6868ce7df3133a9157a&w=826",
      },
      {
            image: "https://img.freepik.com/free-photo/ice-cream-cone_144627-41497.jpg?t=st=1654889259~exp=1654889859~hmac=87242439c775f68064a293a6deb8cbe23becce466ba5d50dee9b082c36a358c0&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/top-view-homemade-ice-cream-scoops-concept_23-2148425380.jpg?t=st=1654889310~exp=1654889910~hmac=fbacb7be231b700ddaef9114b9533bf89571d179a17375f97241df08c0cb23db&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/ice-cream-with-bananas-chocolate-sprinkles-white-plate_114579-33759.jpg?t=st=1654889401~exp=1654890001~hmac=7fb9105f6717da2d2886c995299c5a5df7217d9821c830807cea0e85b607013b&w=740",
},
      ],
    },
    
    {
        id: 20,
        name: "Doner",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 31,
        rating: 5,
        quantity : 1,
        preprice: "",
        category: "desert",
        Image: "https://img.freepik.com/free-photo/side-view-doner-with-grilled-chicken-greens-lettuce-tomato-french-fries-table_141793-4881.jpg?t=st=1654021343~exp=1654021943~hmac=a091ec9468a91768cbea2d4aba6fbf0c42461439ec8644eddd96d825d6c4fb68&w=740",
        sale: "",

        images: [
            {
                image: "https://img.freepik.com/free-photo/side-view-doner-with-grilled-chicken-greens-lettuce-tomato-french-fries-table_141793-4881.jpg?t=st=1654021343~exp=1654021943~hmac=a091ec9468a91768cbea2d4aba6fbf0c42461439ec8644eddd96d825d6c4fb68&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/side-view-chicken-doner-with-greens-cucumber-tomato-sauce-cucumber-red-onion-pita-slice-lemon-board_141793-4824.jpg?t=st=1654889485~exp=1654890085~hmac=a7d98af3b125f9cb719c7cd32451305bf8bd78256aef1f29bc4d0a9c31b62c50&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/side-view-chicken-doner-with-gren-salad-french-fries_141793-2684.jpg?t=st=1654873556~exp=1654874156~hmac=f4ffddcbab0b278fe0edbcc1a6eb0895175fe24186763b3aae3195b6a98ca78e&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/chicken-wrap-doner-with-tomato_140725-10509.jpg?t=st=1654889485~exp=1654890085~hmac=0d2bd8fd1f7995e8f6516763c2c3f77ae1ae2c6475dc2e839aa13b429ae12085&w=740",
},
      ],

    },
    

    {
      id: 21,
      name: "Meat Burger Tomato",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      rating: 5,
     quantity : 1,
      price: 54,
      preprice: "",
      category: "burger",
      Image: "https://img.freepik.com/free-photo/meat-burger-tomato-cucumber-greens-lettuce-ketchup-mayonnaise-side-view_141793-3158.jpg?t=st=1655628688~exp=1655629288~hmac=eb045da8053ca4fd1b24b07ead446f19a8089f90bd5216686ae20194694065be&w=740",
      sale: "",
  
      images: [
          {
              image: "https://img.freepik.com/free-photo/meat-burger-tomato-cucumber-greens-lettuce-ketchup-mayonnaise-side-view_141793-3158.jpg?t=st=1655628688~exp=1655629288~hmac=eb045da8053ca4fd1b24b07ead446f19a8089f90bd5216686ae20194694065be&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
    ],
  
  },


  {
      id: 22,
      name: "hamburger grilled",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      rating: 4,
     quantity : 1,
      price: 22,
      preprice: "",
      category: "burger",
      Image: "https://img.freepik.com/free-photo/side-view-hamburger-grilled-beef-patty-with-melted-cheese-sauce-lettuce-burger-buns-french-fries-table_141793-4953.jpg?t=st=1655628965~exp=1655629565~hmac=f4588071a639a4d675ebc6294a2dc7efc30012482a8e965f724457e696c3eeaf&w=740",
      sale: "",
  
      images: [
          {
              image: "https://img.freepik.com/free-photo/side-view-hamburger-grilled-beef-patty-with-melted-cheese-sauce-lettuce-burger-buns-french-fries-table_141793-4953.jpg?t=st=1655628965~exp=1655629565~hmac=f4588071a639a4d675ebc6294a2dc7efc30012482a8e965f724457e696c3eeaf&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
    ],
  
  },


  {
      id: 23,
      name: "Sandwich chicken burger",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      rating: 5,
     quantity : 1,
      price: 32,
      preprice: "38$",
      category: "burger",
      Image: "https://img.freepik.com/free-photo/sandwich-with-chicken-burger-tomatoes-lettuce_2829-16584.jpg?t=st=1655628965~exp=1655629565~hmac=3508d894236064787a4d90811c9bb74dc06cdfff975edf67af11aca6c972b71b&w=740",
      sale: "SALE ON",
  
      images: [
          {
              image: "https://img.freepik.com/free-photo/sandwich-with-chicken-burger-tomatoes-lettuce_2829-16584.jpg?t=st=1655628965~exp=1655629565~hmac=3508d894236064787a4d90811c9bb74dc06cdfff975edf67af11aca6c972b71b&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
    ],
  
  },


  {
      id: 24,
      name: "Beef burger",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      rating: 3,
     quantity : 1,
      price: 21,
      preprice: "",
      category: "burger",
      Image: "https://img.freepik.com/free-photo/beef-burger-with-chopped-onions-tomatoes-inside-bread-bun-with-french-fries-stone-platter_114579-1865.jpg?t=st=1655629265~exp=1655629865~hmac=405bcae8437e31245b1a4dad79084c69097771c5a018528f7c68b5ed726d6d06&w=740",
      sale: "",
  
      images: [
          {
              image: "https://img.freepik.com/free-photo/beef-burger-with-chopped-onions-tomatoes-inside-bread-bun-with-french-fries-stone-platter_114579-1865.jpg?t=st=1655629265~exp=1655629865~hmac=405bcae8437e31245b1a4dad79084c69097771c5a018528f7c68b5ed726d6d06&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
    ],
  
  },

  {
      id: 25,
      name: "Big mac burger",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      rating: 4,
     quantity : 1,
      price: 33,
      preprice: "",
      category: "burger",
      Image: "https://img.freepik.com/free-photo/big-mac-burger-potatoes-sticks-dark-wooden-board_114579-2362.jpg?t=st=1655629265~exp=1655629865~hmac=2d1c61323bb89e9a94b51d447984beeb978d75d8c0bb565fcbd42675a0d4c9d3&w=740",
      sale: "",
  
      images: [
          {
              image: "https://img.freepik.com/free-photo/big-mac-burger-potatoes-sticks-dark-wooden-board_114579-2362.jpg?t=st=1655629265~exp=1655629865~hmac=2d1c61323bb89e9a94b51d447984beeb978d75d8c0bb565fcbd42675a0d4c9d3&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
    ],
  
  },

  

  {
      id: 26,
      name: " chicken burger",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      rating: 5,
     quantity : 1,
      price: 13,
      preprice: "",
      category: "burger",
      Image: "https://img.freepik.com/free-photo/sandwich-with-chicken-burger-tomatoes-cheese-lettuce_2829-19899.jpg?t=st=1655629265~exp=1655629865~hmac=554ba373d18596df07c975a64442def161d93158deee7443fafc7991f2ed2a58&w=740",
      sale: "",
  
      images: [
          {
              image: "https://img.freepik.com/free-photo/sandwich-with-chicken-burger-tomatoes-cheese-lettuce_2829-19899.jpg?t=st=1655629265~exp=1655629865~hmac=554ba373d18596df07c975a64442def161d93158deee7443fafc7991f2ed2a58&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
    ],
  
  },



  {
      id: 27,
      name: "Beaf Cheeze Burger",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      rating: 5,
     quantity : 1,
      price: 43,
      preprice: "55$",
      category: "burger",
      Image: "https://img.freepik.com/free-photo/beef-burger-with-ingredients_141793-16645.jpg?t=st=1655657789~exp=1655658389~hmac=513d28f4418b48c263aa1ede1192a4f9f8d5dba4b6cd4332a49a423c28acddf3&w=740",
      sale: "SALE ON",
  
      images: [
          {
              image: "https://img.freepik.com/free-photo/beef-burger-with-ingredients_141793-16645.jpg?t=st=1655657789~exp=1655658389~hmac=513d28f4418b48c263aa1ede1192a4f9f8d5dba4b6cd4332a49a423c28acddf3&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
    ],
  
  },



  {
      id: 28,
      name: "Pulled meat burger",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      rating: 4,
     quantity : 1,
      price: 32,
      preprice: "",
      category: "burger",
      Image: "https://img.freepik.com/free-photo/closeup-shot-open-juicy-pulled-meat-burger-surrounded-by-greens-blue-plate_181624-44909.jpg?t=st=1655657789~exp=1655658389~hmac=6873a6b3614ffd2bb4ef0f97d840a90d663ec531a211f445ea5b91dea505ff06&w=826",
      sale: "",
  
      images: [
          {
              image: "https://img.freepik.com/free-photo/closeup-shot-open-juicy-pulled-meat-burger-surrounded-by-greens-blue-plate_181624-44909.jpg?t=st=1655657789~exp=1655658389~hmac=6873a6b3614ffd2bb4ef0f97d840a90d663ec531a211f445ea5b91dea505ff06&w=826",
    },
    {
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
    ],
  
  },



  {
      id: 29,
      name: "Hamburger beef Burger",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      rating: 5,
     quantity : 1,
      price: 34,
      preprice: "",
      category: "burger",
      Image: "https://img.freepik.com/free-photo/side-view-hamburger-with-grilled-beef-patty-fried-bacon-cheese-lettuce-red-onion-tomato-french-fries-plate_141793-4955.jpg?w=740",
      sale: "",
  
      images: [
          {
              image: "https://img.freepik.com/free-photo/side-view-hamburger-with-grilled-beef-patty-fried-bacon-cheese-lettuce-red-onion-tomato-french-fries-plate_141793-4955.jpg?w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
    ],
  
  },


  {
      id: 30,
      name: "Cheese Burger",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      rating: 4,
     quantity : 1,
      price: 44,
      preprice: "50$",
      category: "burger",
      Image: "https://img.freepik.com/free-photo/cheeseburger-with-pickles-fries_141793-120.jpg?w=740",
      sale: "SALE ON",
  
      images: [
          {
              image: "https://img.freepik.com/free-photo/cheeseburger-with-pickles-fries_141793-120.jpg?w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
    ],
  
  },


  {
      id: 31,
      name: "Beaf cheese Burger",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      rating: 5,
     quantity : 1,
      price: 35,
      preprice: "",
      category: "burger",
      Image: "https://img.freepik.com/free-photo/high-angle-glasses-beer-with-cheeseburger-potato-chips_23-2148754927.jpg?w=740",
      sale: "",
  
      images: [
          {
              image: "https://img.freepik.com/free-photo/high-angle-glasses-beer-with-cheeseburger-potato-chips_23-2148754927.jpg?w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
    ],
  
  },



  
  {
      id: 32,
      name: "potatoes Burger",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      rating: 3,
     quantity : 1,
      price: 21,
      preprice: "",
      category: "burger",
      Image: "https://img.freepik.com/free-photo/burger-bun-fried-potatoes-black-bowl-with-ketchup-mustard_114579-3091.jpg?t=st=1655661460~exp=1655662060~hmac=d0a8df74cebb4b006543923934740379f8043ba5cf5726dd7140c496984b0ef3&w=740",
      sale: "",
  
      images: [
          {
              image: "https://img.freepik.com/free-photo/burger-bun-fried-potatoes-black-bowl-with-ketchup-mustard_114579-3091.jpg?t=st=1655661460~exp=1655662060~hmac=d0a8df74cebb4b006543923934740379f8043ba5cf5726dd7140c496984b0ef3&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
    ],
  
  },




  {
      id: 33,
      name: "Tomatoes olives Pizza",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 40,
      quantity : 1,
      rating: 5,
      preprice: "",
      category: "pizza",
      Image: "https://img.freepik.com/free-photo/side-view-pizza-stand-with-tomatoes-olives-bell-peppers_141793-13029.jpg?t=st=1655661647~exp=1655662247~hmac=6f94fa13c26133a25ff4cd0f7c16f68d54cd45b7020c3ddfb03f6b48ff0ff43c&w=740",
      sale: "",
      images: [
          {
              image: "https://img.freepik.com/free-photo/side-view-pizza-stand-with-tomatoes-olives-bell-peppers_141793-13029.jpg?t=st=1655661647~exp=1655662247~hmac=6f94fa13c26133a25ff4cd0f7c16f68d54cd45b7020c3ddfb03f6b48ff0ff43c&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
    ],
  },



  {
      id: 34,
      name: "Tasty chicken pizza",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 38,
      quantity : 1,
      rating: 4,
      preprice: "",
      category: "pizza",
      Image: "https://img.freepik.com/free-photo/tasty-chicken-pizza-with-mushrooms-spices_114579-10735.jpg?t=st=1655661647~exp=1655662247~hmac=2c2ab548ab2955377ce7072348f956a7a2530587b1ae7e04a7787ccb13e35cc7&w=740",
      sale: "",
      images: [
          {
              image: "https://img.freepik.com/free-photo/tasty-chicken-pizza-with-mushrooms-spices_114579-10735.jpg?t=st=1655661647~exp=1655662247~hmac=2c2ab548ab2955377ce7072348f956a7a2530587b1ae7e04a7787ccb13e35cc7&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
    ],
  },



  {
      id: 35,
      name: "Tomatos Pizza",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 51,
      quantity : 1,
      rating: 5,
      preprice: "",
      category: "pizza",
      Image: "https://img.freepik.com/free-photo/mixed-pizza-with-meat-chicken-pepperoni_140725-5872.jpg?t=st=1655661647~exp=1655662247~hmac=d6fba852e276c6816e0623c38dcf2279b8b700e1369b9c763ae1c13af5384197&w=740",
      sale: "",
      images: [
          {
              image: "https://img.freepik.com/free-photo/mixed-pizza-with-meat-chicken-pepperoni_140725-5872.jpg?t=st=1655661647~exp=1655662247~hmac=d6fba852e276c6816e0623c38dcf2279b8b700e1369b9c763ae1c13af5384197&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
    ],
  },





  {
      id: 36,
      name: "Mushroom pizza",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 21,
      quantity : 1,
      rating: 5,
      preprice: "30$",
      category: "pizza",
      Image: "https://img.freepik.com/free-photo/mushroom-pizza-with-tomato-sauce-served-round-bamboo-board_114579-1908.jpg?t=st=1655661647~exp=1655662247~hmac=25b96ff092d77aaeaeeafc29697c93057fc158061ec964ba5a56ead878562cca&w=740",
      sale: "SALE ON",
      images: [
          {
              image: "https://img.freepik.com/free-photo/mushroom-pizza-with-tomato-sauce-served-round-bamboo-board_114579-1908.jpg?t=st=1655661647~exp=1655662247~hmac=25b96ff092d77aaeaeeafc29697c93057fc158061ec964ba5a56ead878562cca&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
    ],
  },


  {
      id: 37,
      name: "Mushroom Cheeze pizza",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 35,
      quantity : 1,
      rating: 4,
      preprice: "",
      category: "pizza",
      Image: "https://img.freepik.com/free-photo/mushroom-pizza-slice-cut-off-wooden-board_114579-2286.jpg?t=st=1655661893~exp=1655662493~hmac=bc86954a56c77ef1e8b02aa09a7ea09fc7b8ce0313fe0566bd44e241e391b2c8&w=740",
      sale: "",
      images: [
          {
              image: "https://img.freepik.com/free-photo/mushroom-pizza-slice-cut-off-wooden-board_114579-2286.jpg?t=st=1655661893~exp=1655662493~hmac=bc86954a56c77ef1e8b02aa09a7ea09fc7b8ce0313fe0566bd44e241e391b2c8&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
    ],
  },


  {
      id: 38,
      name: "chicken pizza",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 30,
      quantity : 1,
      rating: 4,
      preprice: "",
      category: "pizza",
      Image: "https://img.freepik.com/free-photo/top-view-chicken-pizza-with-green-bell-pepper-mushroom-cheese-tomato-sauce_141793-2429.jpg?t=st=1655662027~exp=1655662627~hmac=df8cb5b9591f4e12522c0f016789f4286b47c951038676c4fa6066f2a4b7f95d&w=740",
      sale: "",
      images: [
          {
              image: "https://img.freepik.com/free-photo/top-view-chicken-pizza-with-green-bell-pepper-mushroom-cheese-tomato-sauce_141793-2429.jpg?t=st=1655662027~exp=1655662627~hmac=df8cb5b9591f4e12522c0f016789f4286b47c951038676c4fa6066f2a4b7f95d&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
    ],
  },

  {
      id: 39,
      name: "Onion Cheeze Pizza",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 43,
      quantity : 1,
      rating: 5,
      preprice: "",
      category: "pizza",
      Image: "https://img.freepik.com/free-photo/family-lunch-eating-pizza-ham-cheese-recipe_1150-17477.jpg?t=st=1655662027~exp=1655662627~hmac=6f66dad129947fff4eacb61764fea56d795b0104b60dcbfa2e18198306f0b1c6&w=900",
      sale: "",
      images: [
          {
              image: "https://img.freepik.com/free-photo/family-lunch-eating-pizza-ham-cheese-recipe_1150-17477.jpg?t=st=1655662027~exp=1655662627~hmac=6f66dad129947fff4eacb61764fea56d795b0104b60dcbfa2e18198306f0b1c6&w=900",
    },
    {
          image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
    ],
  },





  {
      id: 40,
      name: " Olives,tomato Pizza",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 20,
      quantity : 1,
      rating: 4,
      preprice: "",
      category: "pizza",
      Image: "https://img.freepik.com/free-photo/mixed-ingredient-pizza-with-olives-tomato-pepperoni_114579-2999.jpg?t=st=1655662027~exp=1655662627~hmac=e53298c7b59214bfd468197284224bdf2a4aacc1c285b68ed3a2a78fa727f9f9&w=740",
      sale: "",
      images: [
          {
              image: "https://img.freepik.com/free-photo/mixed-ingredient-pizza-with-olives-tomato-pepperoni_114579-2999.jpg?t=st=1655662027~exp=1655662627~hmac=e53298c7b59214bfd468197284224bdf2a4aacc1c285b68ed3a2a78fa727f9f9&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
    ],
  },



  {
      id: 41,
      name: " Olives,tomato Pizza",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 20,
      quantity : 1,
      rating: 4,
      preprice: "",
      category: "pizza",
      Image: "https://img.freepik.com/free-photo/high-angle-delicious-square-pizza_23-2149235569.jpg?t=st=1655662027~exp=1655662627~hmac=98c03d44ad980acef6816b7f09b6e180a67073768ef8b413119709d805389121&w=740",
      sale: "",
      images: [
          {
              image: "https://img.freepik.com/free-photo/high-angle-delicious-square-pizza_23-2149235569.jpg?t=st=1655662027~exp=1655662627~hmac=98c03d44ad980acef6816b7f09b6e180a67073768ef8b413119709d805389121&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
    ],
  },




  
  {
      id: 42,
      name: "Tomatoes colorful Pizza",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 40,
      quantity : 1,
      rating: 4,
      preprice: "50$",
      category: "pizza",
      Image: "https://img.freepik.com/free-photo/top-view-pizza-filled-with-tomatoes-colorful-bell-peppers-salami-olives-wooden-board_140725-10375.jpg?t=st=1655662027~exp=1655662627~hmac=b9596bcfbeac1c92b5ab672aaeba1969ab44a05b902da1367fee95b45ed12352&w=740",
      sale: "SALE ON",
      images: [
          {
              image: "https://img.freepik.com/free-photo/top-view-pizza-filled-with-tomatoes-colorful-bell-peppers-salami-olives-wooden-board_140725-10375.jpg?t=st=1655662027~exp=1655662627~hmac=b9596bcfbeac1c92b5ab672aaeba1969ab44a05b902da1367fee95b45ed12352&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
    ],
  },


  {
      id: 43,
      name: "Milk Pizza",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 28,
      quantity : 1,
      rating: 5,
      preprice: "",
      category: "pizza",
      Image: "https://img.freepik.com/free-photo/front-view-pizza-with-cheese-brown-round-wooden-desk-dark-surface_140725-14476.jpg?t=st=1655662027~exp=1655662627~hmac=fd62276a6e4597c075a7773dc8a5bca83fb60263aa8be14a1be90361b0018d4b&w=740",
      sale: "",
      images: [
          {
              image: "https://img.freepik.com/free-photo/front-view-pizza-with-cheese-brown-round-wooden-desk-dark-surface_140725-14476.jpg?t=st=1655662027~exp=1655662627~hmac=fd62276a6e4597c075a7773dc8a5bca83fb60263aa8be14a1be90361b0018d4b&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
    ],
  },





  {
      id: 44,
      name: "Tikka Pizza",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 29,
      quantity : 1,
      rating: 4,
      preprice: "",
      category: "pizza",
      Image: "https://img.freepik.com/free-photo/side-view-eggplant-pizza-with-grilled-slices-red-meat-bell-pepper-cheese-tomato-table_141793-4889.jpg?t=st=1655662027~exp=1655662627~hmac=2f545e7fa012deab0054d05c6e920f81cdc10c45507a1c06545dfdbda4770de9&w=740",
      sale: "",
      images: [
          {
              image: "https://img.freepik.com/free-photo/side-view-eggplant-pizza-with-grilled-slices-red-meat-bell-pepper-cheese-tomato-table_141793-4889.jpg?t=st=1655662027~exp=1655662627~hmac=2f545e7fa012deab0054d05c6e920f81cdc10c45507a1c06545dfdbda4770de9&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
    ],
  },





  {
      id: 45,
      name: "Big Cheese Pizza",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 37,
      quantity : 1,
      rating: 5,
      preprice: "",
      category: "pizza",
      Image: "https://img.freepik.com/free-photo/pizza-with-sausage-corn-beans-shrimp-bacon-wooden-plate_1150-27089.jpg?t=st=1655662027~exp=1655662627~hmac=3a280f2ad543d1a5ed933c7949adc0e6d1c6bf2ed5eb6d4a3831580b79e4a89a&w=740",
      sale: "",
      images: [
          {
              image: "https://img.freepik.com/free-photo/pizza-with-sausage-corn-beans-shrimp-bacon-wooden-plate_1150-27089.jpg?t=st=1655662027~exp=1655662627~hmac=3a280f2ad543d1a5ed933c7949adc0e6d1c6bf2ed5eb6d4a3831580b79e4a89a&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
    ],
  },





  {
      id: 46,
      name: "Tikka Pizza",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 37,
      quantity : 1,
      rating: 4,
      preprice: "43$",
      category: "pizza",
      Image: "https://img.freepik.com/free-photo/hawaiian-pizza-isolated-white-background_123827-20895.jpg?t=st=1655662027~exp=1655662627~hmac=2616936af44b9b5c3ec9a85e7f9128b0de86a68d2ee94f7d87dcc22c2b2f5c3a&w=740",
      sale: "SALE ON",
      images: [
          {
              image: "https://img.freepik.com/free-photo/hawaiian-pizza-isolated-white-background_123827-20895.jpg?t=st=1655662027~exp=1655662627~hmac=2616936af44b9b5c3ec9a85e7f9128b0de86a68d2ee94f7d87dcc22c2b2f5c3a&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
    ],
  },



  {
      id: 47,
      name: "crab and salmon sushi",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 32,
      quantity : 1,
      rating: 4,
      preprice: "",
      category: "sushi",
      Image: "https://img.freepik.com/free-photo/plate-tasty-crab-salmon-sushi-rolls_181624-31889.jpg?t=st=1655662901~exp=1655663501~hmac=8195739555a63922aaad925d75933a4c920a7f830d41e86213e471a912c6bcfb&w=740",
      sale: "",

      images: [
          {
              image: "https://img.freepik.com/free-photo/plate-tasty-crab-salmon-sushi-rolls_181624-31889.jpg?t=st=1655662901~exp=1655663501~hmac=8195739555a63922aaad925d75933a4c920a7f830d41e86213e471a912c6bcfb&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
    ],

  },



  {
      id: 48,
      name: "cream cheese sushi",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 22,
      quantity : 1,
      rating: 3,
      preprice: "",
      category: "sushi",
      Image: "https://img.freepik.com/free-photo/california-roll-crab-cream-cheese-ginger-wasabi-top-view_141793-15466.jpg?t=st=1655662901~exp=1655663501~hmac=cba6a678bb69fc58cf3fc442fb8ae7c064abf04ac563aba3a13ab876bc6521c7&w=740",
      sale: "",

      images: [
          {
              image: "https://img.freepik.com/free-photo/california-roll-crab-cream-cheese-ginger-wasabi-top-view_141793-15466.jpg?t=st=1655662901~exp=1655663501~hmac=cba6a678bb69fc58cf3fc442fb8ae7c064abf04ac563aba3a13ab876bc6521c7&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
    ],

  },



  {
      id: 49,
      name: "Maki sushi",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 24,
      quantity : 1,
      rating: 4,
      preprice: "29$",
      category: "sushi",
      Image: "https://img.freepik.com/free-photo/maki-sushi-isolated-white_2829-5653.jpg?t=st=1655662901~exp=1655663501~hmac=685217d05724996021af920078f478fcb01e2af11d49c12b502e3d2bd83563b4&w=740",
      sale: "SALE ON",

      images: [
          {
              image: "https://img.freepik.com/free-photo/maki-sushi-isolated-white_2829-5653.jpg?t=st=1655662901~exp=1655663501~hmac=685217d05724996021af920078f478fcb01e2af11d49c12b502e3d2bd83563b4&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
    ],

  },

  {
      id: 50,
      name: "Japanese Sushi",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 36,
      quantity : 1,
      rating: 4,
      preprice: "",
      category: "sushi",
      Image: "https://img.freepik.com/free-photo/top-view-japanese-sushi-arrangement_23-2148809937.jpg?t=st=1655662901~exp=1655663501~hmac=339f668dd07e9f6aa88d591dde475c355974334baa9e4036336fa1fe1148ceb2&w=740",
      sale: "",

      images: [
          {
              image: "https://img.freepik.com/free-photo/top-view-japanese-sushi-arrangement_23-2148809937.jpg?t=st=1655662901~exp=1655663501~hmac=339f668dd07e9f6aa88d591dde475c355974334baa9e4036336fa1fe1148ceb2&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
    ],

  },


  {
      id: 51,
      name: "wasabi and chopsticks",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 48,
      quantity : 1,
      rating: 5,
      preprice: "",
      category: "sushi",
      Image: "https://img.freepik.com/free-photo/sushi-day-concept-with-wasabi-chopsticks_23-2148494385.jpg?t=st=1655662901~exp=1655663501~hmac=0d8c7f9ba47f90406685a21443314f580ff243d303cf66ad81aaafdefbb2aaff&w=740",
      sale: "",

      images: [
          {
              image: "https://img.freepik.com/free-photo/sushi-day-concept-with-wasabi-chopsticks_23-2148494385.jpg?t=st=1655662901~exp=1655663501~hmac=0d8c7f9ba47f90406685a21443314f580ff243d303cf66ad81aaafdefbb2aaff&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
    ],

  },



  {
      id: 52,
      name: "Salad & Fresh Sushi",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 51,
      quantity : 1,
      rating: 5,
      preprice: "",
      category: "sushi",
      Image: "https://img.freepik.com/free-photo/salad-fresh-sushi-rolls_23-2148631206.jpg?t=st=1655662901~exp=1655663501~hmac=78ead11f276eb5afb08f6aa4b716ce07688b1148c9075d9e051dcd166f380963&w=900",
      sale: "",

      images: [
          {
              image: "https://img.freepik.com/free-photo/salad-fresh-sushi-rolls_23-2148631206.jpg?t=st=1655662901~exp=1655663501~hmac=78ead11f276eb5afb08f6aa4b716ce07688b1148c9075d9e051dcd166f380963&w=900",
    },
    {
          image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
    ],

  },


  {
      id: 53,
      name: "Sushi Roll",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 41,
      quantity : 1,
      rating: 4,
      preprice: "",
      category: "sushi",
      Image: "https://img.freepik.com/free-photo/sushi-rolls-with-soy-sauce-placed-brown-plate_114579-90614.jpg?t=st=1655662901~exp=1655663501~hmac=71646e4bba27f503a75dcf5e15f01fbf00c49e4b0ad522ec8ba3c0635b364ca3&w=740",
      sale: "",

      images: [
          {
              image: "https://img.freepik.com/free-photo/sushi-rolls-with-soy-sauce-placed-brown-plate_114579-90614.jpg?t=st=1655662901~exp=1655663501~hmac=71646e4bba27f503a75dcf5e15f01fbf00c49e4b0ad522ec8ba3c0635b364ca3&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
    ],

  },



  {
      id: 54,
      name: "Food with Sushi",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 36,
      quantity : 1,
      rating: 5,
      preprice: "",
      category: "sushi",
      Image: "https://img.freepik.com/free-photo/concept-tasty-food-with-sushi-close-up_185193-78065.jpg?t=st=1655662901~exp=1655663501~hmac=2969d774055e825a67f3c03e0cede4ce9375a0464e6f2b49fc761487b64c723b&w=740",
      sale: "",

      images: [
          {
              image: "https://img.freepik.com/free-photo/concept-tasty-food-with-sushi-close-up_185193-78065.jpg?t=st=1655662901~exp=1655663501~hmac=2969d774055e825a67f3c03e0cede4ce9375a0464e6f2b49fc761487b64c723b&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
    ],

  },


  {
      id: 55,
      name: "Sushi set with avocado",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 76,
      quantity : 1,
      rating: 4,
      preprice: "89$",
      category: "sushi",
      Image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1655663695~exp=1655664295~hmac=71100ef8f843e5f5be56e92863c3b573bf30034b519485921f7fda1eb588f0ea&w=740",
      sale: "SALE ON",

      images: [
          {
              image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1655663695~exp=1655664295~hmac=71100ef8f843e5f5be56e92863c3b573bf30034b519485921f7fda1eb588f0ea&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
    ],

  },


  {
      id: 56,
      name: "Cheese Sushi",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 34,
      quantity : 1,
      rating: 4,
      preprice: "",
      category: "sushi",
      Image: "https://img.freepik.com/free-photo/variety-mix-sushi-rolls-black-background-studio-photo_482257-24226.jpg?t=st=1655663695~exp=1655664295~hmac=ef56a58555c047faf088e4a89905310f914b587d41e48ddea06b68c05d47a176&w=740",
      sale: "",

      images: [
          {
              image: "https://img.freepik.com/free-photo/variety-mix-sushi-rolls-black-background-studio-photo_482257-24226.jpg?t=st=1655663695~exp=1655664295~hmac=ef56a58555c047faf088e4a89905310f914b587d41e48ddea06b68c05d47a176&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
    ],

  },



  {
      id: 57,
      name: "Penne pasta",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 15,
      rating: 4,
      quantity : 1,
      preprice: "",
      category: "salat",
      Image: "https://img.freepik.com/free-photo/penne-pasta-with-pesto-sauce-zucchini-green-peas-basil-italian-food-top-view-flat-lay_2829-19620.jpg?t=st=1655663972~exp=1655664572~hmac=3fb28b0c123c649a34105f46b9f7916bfdbc53b54a6df06b6e06496c9361cac9&w=740",
      sale: "",
      images: [
          {
              image: "https://img.freepik.com/free-photo/penne-pasta-with-pesto-sauce-zucchini-green-peas-basil-italian-food-top-view-flat-lay_2829-19620.jpg?t=st=1655663972~exp=1655664572~hmac=3fb28b0c123c649a34105f46b9f7916bfdbc53b54a6df06b6e06496c9361cac9&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/side-view-delicious-vegetarian-meal-plate-purple-stripped-towel-dark-background_140725-130417.jpg?t=st=1654888690~exp=1654889290~hmac=f8978389ef98f1f0c3a75d26325860c2897892362634fe0961be0fa7384a05aa&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/top-view-salad-with-different-ingredients-dark-plate_23-2148537175.jpg?t=st=1654888613~exp=1654889213~hmac=3ababa987f894621db67916f748861486f4499398ec6b223eb24b6735b926076&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/top-view-caesar-salad-oval-grey-plate-green-white-checkered-tablecloth-dark-red-background_140725-124350.jpg?t=st=1654888690~exp=1654889290~hmac=2d7198257959eb570f5daa897e217a9e2776052dcb08493e8fa41c71c9454c24&w=740",
},
    ],

  },

  
  {
      id: 58,
      name: "Vegetable Salad",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 21,
      rating: 5,
      quantity : 1,
      preprice: "",
      category: "salat",
      Image: "https://img.freepik.com/free-photo/classic-greek-salad-fresh-vegetables-cucumber-tomato-sweet-pepper-lettuce-red-onion-feta-cheese-olives-with-olive-oil-healthy-food-top-view_1150-44957.jpg?t=st=1655663972~exp=1655664572~hmac=7986ad3c33506b7727d8e7d1c42279a1d36fdce6eed698a0fde0171c8ae1e7eb&w=740",
      sale: "",
      images: [
          {
              image: "https://img.freepik.com/free-photo/classic-greek-salad-fresh-vegetables-cucumber-tomato-sweet-pepper-lettuce-red-onion-feta-cheese-olives-with-olive-oil-healthy-food-top-view_1150-44957.jpg?t=st=1655663972~exp=1655664572~hmac=7986ad3c33506b7727d8e7d1c42279a1d36fdce6eed698a0fde0171c8ae1e7eb&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/side-view-delicious-vegetarian-meal-plate-purple-stripped-towel-dark-background_140725-130417.jpg?t=st=1654888690~exp=1654889290~hmac=f8978389ef98f1f0c3a75d26325860c2897892362634fe0961be0fa7384a05aa&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/top-view-salad-with-different-ingredients-dark-plate_23-2148537175.jpg?t=st=1654888613~exp=1654889213~hmac=3ababa987f894621db67916f748861486f4499398ec6b223eb24b6735b926076&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/top-view-caesar-salad-oval-grey-plate-green-white-checkered-tablecloth-dark-red-background_140725-124350.jpg?t=st=1654888690~exp=1654889290~hmac=2d7198257959eb570f5daa897e217a9e2776052dcb08493e8fa41c71c9454c24&w=740",
},
    ],

  },



  {
      id: 59,
      name: "Healthy hearty salad",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 29,
      rating: 5,
      quantity : 1,
      preprice: "35$",
      category: "salat",
      Image: "https://img.freepik.com/free-photo/healthy-hearty-salad-tuna-green-beans-tomatoes-eggs-potatoes-black-olives-close-up-bowl-table_2829-4486.jpg?t=st=1655663972~exp=1655664572~hmac=3fa72fe8c9f969e2d8c9d69a7be9bb2f57823789a0dc004f7a4ffacfb4f3a34a&w=740",
      sale: "SALE ON",
      images: [
          {
              image: "https://img.freepik.com/free-photo/healthy-hearty-salad-tuna-green-beans-tomatoes-eggs-potatoes-black-olives-close-up-bowl-table_2829-4486.jpg?t=st=1655663972~exp=1655664572~hmac=3fa72fe8c9f969e2d8c9d69a7be9bb2f57823789a0dc004f7a4ffacfb4f3a34a&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/side-view-delicious-vegetarian-meal-plate-purple-stripped-towel-dark-background_140725-130417.jpg?t=st=1654888690~exp=1654889290~hmac=f8978389ef98f1f0c3a75d26325860c2897892362634fe0961be0fa7384a05aa&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/top-view-salad-with-different-ingredients-dark-plate_23-2148537175.jpg?t=st=1654888613~exp=1654889213~hmac=3ababa987f894621db67916f748861486f4499398ec6b223eb24b6735b926076&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/top-view-caesar-salad-oval-grey-plate-green-white-checkered-tablecloth-dark-red-background_140725-124350.jpg?t=st=1654888690~exp=1654889290~hmac=2d7198257959eb570f5daa897e217a9e2776052dcb08493e8fa41c71c9454c24&w=740",
},
    ],

  },




  {
      id: 60,
      name: "Diet food",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 27,
      rating: 4,
      quantity : 1,
      preprice: "",
      category: "salat",
      Image: "https://img.freepik.com/free-photo/plate-with-paleo-diet-food-boiled-eggs-avocado-cucumber-nuts-cherry-strawberries-paleo-breakfast-top-view_2829-17450.jpg?t=st=1655663972~exp=1655664572~hmac=d4d9ea735b50af2d1d72861158a5ef4d1f49c21527f2a06276e8d020c27712ae&w=826",
      sale: "",
      images: [
          {
              image: "https://img.freepik.com/free-photo/plate-with-paleo-diet-food-boiled-eggs-avocado-cucumber-nuts-cherry-strawberries-paleo-breakfast-top-view_2829-17450.jpg?t=st=1655663972~exp=1655664572~hmac=d4d9ea735b50af2d1d72861158a5ef4d1f49c21527f2a06276e8d020c27712ae&w=826",
    },
    {
          image: "https://img.freepik.com/free-photo/side-view-delicious-vegetarian-meal-plate-purple-stripped-towel-dark-background_140725-130417.jpg?t=st=1654888690~exp=1654889290~hmac=f8978389ef98f1f0c3a75d26325860c2897892362634fe0961be0fa7384a05aa&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/top-view-salad-with-different-ingredients-dark-plate_23-2148537175.jpg?t=st=1654888613~exp=1654889213~hmac=3ababa987f894621db67916f748861486f4499398ec6b223eb24b6735b926076&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/top-view-caesar-salad-oval-grey-plate-green-white-checkered-tablecloth-dark-red-background_140725-124350.jpg?t=st=1654888690~exp=1654889290~hmac=2d7198257959eb570f5daa897e217a9e2776052dcb08493e8fa41c71c9454c24&w=740",
},
    ],

  },



  {
      id: 61,
      name: "Fruit Salad",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 20,
      rating: 5,
      quantity : 1,
      preprice: "",
      category: "salat",
      Image: "https://img.freepik.com/free-photo/top-view-green-apple-salad-plate-fork-knife-dark-blue-table_140725-145493.jpg?t=st=1655663972~exp=1655664572~hmac=0a385fda1548afd5ade6e1f9ab65cae95511c9e98923d2a229b74cb73cbe3327&w=740",
      sale: "",
      images: [
          {
              image: "https://img.freepik.com/free-photo/top-view-green-apple-salad-plate-fork-knife-dark-blue-table_140725-145493.jpg?t=st=1655663972~exp=1655664572~hmac=0a385fda1548afd5ade6e1f9ab65cae95511c9e98923d2a229b74cb73cbe3327&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/side-view-delicious-vegetarian-meal-plate-purple-stripped-towel-dark-background_140725-130417.jpg?t=st=1654888690~exp=1654889290~hmac=f8978389ef98f1f0c3a75d26325860c2897892362634fe0961be0fa7384a05aa&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/top-view-salad-with-different-ingredients-dark-plate_23-2148537175.jpg?t=st=1654888613~exp=1654889213~hmac=3ababa987f894621db67916f748861486f4499398ec6b223eb24b6735b926076&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/top-view-caesar-salad-oval-grey-plate-green-white-checkered-tablecloth-dark-red-background_140725-124350.jpg?t=st=1654888690~exp=1654889290~hmac=2d7198257959eb570f5daa897e217a9e2776052dcb08493e8fa41c71c9454c24&w=740",
},
    ],

  },






  {
      id: 62,
      name: "Chicken Salad",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 31,
      rating: 4,
      quantity : 1,
      preprice: "",
      category: "salat",
      Image: "https://img.freepik.com/free-photo/chicken-ceasar-salad-table_140725-699.jpg?t=st=1655663972~exp=1655664572~hmac=eab1a38e66127937a94b946b491a2dc97e847680bea357e11acd58ddfd0b28ef&w=740",
      sale: "",
      images: [
          {
              image: "https://img.freepik.com/free-photo/chicken-ceasar-salad-table_140725-699.jpg?t=st=1655663972~exp=1655664572~hmac=eab1a38e66127937a94b946b491a2dc97e847680bea357e11acd58ddfd0b28ef&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/side-view-delicious-vegetarian-meal-plate-purple-stripped-towel-dark-background_140725-130417.jpg?t=st=1654888690~exp=1654889290~hmac=f8978389ef98f1f0c3a75d26325860c2897892362634fe0961be0fa7384a05aa&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/top-view-salad-with-different-ingredients-dark-plate_23-2148537175.jpg?t=st=1654888613~exp=1654889213~hmac=3ababa987f894621db67916f748861486f4499398ec6b223eb24b6735b926076&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/top-view-caesar-salad-oval-grey-plate-green-white-checkered-tablecloth-dark-red-background_140725-124350.jpg?t=st=1654888690~exp=1654889290~hmac=2d7198257959eb570f5daa897e217a9e2776052dcb08493e8fa41c71c9454c24&w=740",
},
    ],

  },

  {
      id: 63,
      name: "Three Donots",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 20,
      rating: 4,
      quantity : 1,
      preprice: "",
      category: "desert",
      Image: "https://img.freepik.com/free-photo/delicious-donuts_144627-6267.jpg?t=st=1655664535~exp=1655665135~hmac=ba9c6922725e6f1628e91fab6d7d0e2dceac07f812e6bdf82f6d569c4793a74c&w=740",
      sale: "",

      images: [
          {
              image: "https://img.freepik.com/free-photo/delicious-donuts_144627-6267.jpg?t=st=1655664535~exp=1655665135~hmac=ba9c6922725e6f1628e91fab6d7d0e2dceac07f812e6bdf82f6d569c4793a74c&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/sponge-cake-with-strawberries-top_144627-45517.jpg?t=st=1654889048~exp=1654889648~hmac=2401a3a76cb5174dab4308210a31609252f7e0381ec605f6b8d12e862969e71c&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/assortment-pieces-cake_114579-28298.jpg?t=st=1654889048~exp=1654889648~hmac=e0f48369eefeaa89e954ec6f3dac8a179a3bf872fd385b06f720d7c42b4fda75&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/stunning-birthday-cake-covered-with-pink-icing-roses_8353-1076.jpg?t=st=1654889048~exp=1654889648~hmac=51e0b8842f21bd8981ad8fa2406f10145b170fe8e0454af69e1c3808c29476d9&w=740",
},
    ],
  },



  {
      id: 64,
      name: "Pinut Cake",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 35,
      rating: 4,
      quantity : 1,
      preprice: "41$",
      category: "desert",
      Image: "https://img.freepik.com/free-photo/side-view-fruit-cake-with-vanilla-cream-chocolate-kiwi-orange-strawberry-pineapple-pastries-table_141793-4924.jpg?t=st=1655664535~exp=1655665135~hmac=1e672de15d1767d3e60dab390bdd998526153e5f5223f7d4653b8937718dfda3&w=900",
      sale: "SALE ON",

      images: [
          {
              image: "https://img.freepik.com/free-photo/side-view-fruit-cake-with-vanilla-cream-chocolate-kiwi-orange-strawberry-pineapple-pastries-table_141793-4924.jpg?t=st=1655664535~exp=1655665135~hmac=1e672de15d1767d3e60dab390bdd998526153e5f5223f7d4653b8937718dfda3&w=900",
    },
    {
          image: "https://img.freepik.com/free-photo/sponge-cake-with-strawberries-top_144627-45517.jpg?t=st=1654889048~exp=1654889648~hmac=2401a3a76cb5174dab4308210a31609252f7e0381ec605f6b8d12e862969e71c&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/assortment-pieces-cake_114579-28298.jpg?t=st=1654889048~exp=1654889648~hmac=e0f48369eefeaa89e954ec6f3dac8a179a3bf872fd385b06f720d7c42b4fda75&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/stunning-birthday-cake-covered-with-pink-icing-roses_8353-1076.jpg?t=st=1654889048~exp=1654889648~hmac=51e0b8842f21bd8981ad8fa2406f10145b170fe8e0454af69e1c3808c29476d9&w=740",
},
    ],
  },



  {
      id: 65,
      name: "birthday cake",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 42,
      rating: 4,
      quantity : 1,
      preprice: "",
      category: "desert",
      Image: "https://img.freepik.com/free-photo/caramel-cake-chocolate-nuts-decorations_140725-5743.jpg?t=st=1655664700~exp=1655665300~hmac=2d3efe895994f5882ee13ce0ded7eb795cc3340c2dba21aaa485aa5a4d9a2438&w=740",
      sale: "",

      images: [
          {
              image: "https://img.freepik.com/free-photo/caramel-cake-chocolate-nuts-decorations_140725-5743.jpg?t=st=1655664700~exp=1655665300~hmac=2d3efe895994f5882ee13ce0ded7eb795cc3340c2dba21aaa485aa5a4d9a2438&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/sponge-cake-with-strawberries-top_144627-45517.jpg?t=st=1654889048~exp=1654889648~hmac=2401a3a76cb5174dab4308210a31609252f7e0381ec605f6b8d12e862969e71c&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/assortment-pieces-cake_114579-28298.jpg?t=st=1654889048~exp=1654889648~hmac=e0f48369eefeaa89e954ec6f3dac8a179a3bf872fd385b06f720d7c42b4fda75&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/stunning-birthday-cake-covered-with-pink-icing-roses_8353-1076.jpg?t=st=1654889048~exp=1654889648~hmac=51e0b8842f21bd8981ad8fa2406f10145b170fe8e0454af69e1c3808c29476d9&w=740",
},
    ],
  },



  
  {
      id: 66,
      name: "Tasty homemade tiramisu",
      description: "This impressive paella is a perfect party dish and a fun meal to cook",
      detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
      price: 33,
      rating: 4,
      quantity : 1,
      preprice: "",
      category: "desert",
      Image: "https://img.freepik.com/free-photo/tasty-homemade-tiramisu-cake_114579-85350.jpg?t=st=1655664799~exp=1655665399~hmac=0e7f4aa3d57c44a49efefc22e6250dc53893742d5cc7d0ec43230d88b74e82c1&w=740",
      sale: "",

      images: [
          {
              image: "https://img.freepik.com/free-photo/tasty-homemade-tiramisu-cake_114579-85350.jpg?t=st=1655664799~exp=1655665399~hmac=0e7f4aa3d57c44a49efefc22e6250dc53893742d5cc7d0ec43230d88b74e82c1&w=740",
    },
    {
          image: "https://img.freepik.com/free-photo/sponge-cake-with-strawberries-top_144627-45517.jpg?t=st=1654889048~exp=1654889648~hmac=2401a3a76cb5174dab4308210a31609252f7e0381ec605f6b8d12e862969e71c&w=740",
    },
{
          image: "https://img.freepik.com/free-photo/assortment-pieces-cake_114579-28298.jpg?t=st=1654889048~exp=1654889648~hmac=e0f48369eefeaa89e954ec6f3dac8a179a3bf872fd385b06f720d7c42b4fda75&w=740",
},
{  
          image: "https://img.freepik.com/free-photo/stunning-birthday-cake-covered-with-pink-icing-roses_8353-1076.jpg?t=st=1654889048~exp=1654889648~hmac=51e0b8842f21bd8981ad8fa2406f10145b170fe8e0454af69e1c3808c29476d9&w=740",
},
    ],
  },



]
    
    
    export default MenuData;